import axios from "axios";
export default {
  namespaced: true,
  state: {
    templates: [],
  },
  getters: {
    templates(state) {
      return state.templates;
    },
    active_templates(state) {
      return state.templates.filter((t) => t.is_active);
    },
  },
  mutations: {
    SET_TEMPLATES(state, templates) {
      state.templates = templates;
    },
    ADD_TEMPLATE(state, template) {
      state.templates.unshift(template);
    },
    EDIT_TEMPLATE(state, template) {
      var index = state.templates.findIndex((a) => a.id == template.id);
      if (index !== -1) {
        state.templates.splice(index, 1, template);
      }
    },
    DELETE_TEMPLATE(state, templateId) {
      var index = state.templates.findIndex((a) => a.id == templateId);
      if (index !== -1) {
        // Mark as inactive rather than remove (soft delete)
        state.templates[index].is_active = false;
      }
    },
  },
  actions: {
    async get_templates({ commit }) {
      let response = await axios.get("/task_templates");
      commit("SET_TEMPLATES", response.data);
    },
    async create_template({ commit }, payload) {
      let response = await axios.post("/task_template", payload);
      commit("ADD_TEMPLATE", response.data);
      return response.data;
    },
    async update_template({ commit }, payload) {
      let response = await axios.put("/task_template", payload);
      commit("EDIT_TEMPLATE", response.data);
      return response.data;
    },
    async delete_template({ commit }, id) {
      await axios.delete("/task_template/" + id);
      commit("DELETE_TEMPLATE", id);
    },
  },
};
